<vb-breadcrumb-one title="About Us" [disableTitle]="true"></vb-breadcrumb-one>

<section>
    <div class="container-fluid mt-4 mb-4">
          <div>
              <vb-page-header
                  class="mb-4"
                  heading="About Us"
                  subtitle="Viewbid Auctions is Nova Scotia's First Online Only Auction House">
              </vb-page-header>
              <p>
                  Viewbid is open to the general public and broadcasts
                  live timed online auctions 24 hours a day, 7 days a
                  week, from multiple buildings located in the city of
                  Halifax. We have staff with combined auction experience
                  of over 100 years in all aspects.
              </p>
              <p>
                  Viewbid Auctions currently has over 21,000 users from
                  all over Canada and the world.
              </p>
              <p>
                  Viewbid Auctions carries accounts with all major banks,
                  trustees, personal lenders, retailers, manufacturers,
                  liquidations, private and corporate consignments, and
                  estates.
              </p>
              <p>
                  Viewbid has an active dealers permit through its sister
                  company Auction Advantage, which allows us to list and
                  sell vehicles, trailers, off-highway vehicles to the
                  general public. By buying titled equipment through our
                  auction house, the process is painless, and we can
                  transfer ownerships into new purchasers' names without
                  any issues. Viewbid auctions is one of only a handful of
                  auction houses that carry this license in Nova Scotia,
                  which is required by law.
              </p>
              <p>
                  Viewbid is able to conduct onsite-online specialty
                  auctions throughout the Maritimes.
              </p>
          </div>
    </div>
</section>
